TS.ns('WL');

WL.documentTemplateModel = new Class({
    Extends: TS.domain.EditDomain,

    initialize: function (config) {
        var me = this;

        me.parent(config);
    },

    createProperties: function (config) {
        var me = this;

        me.parent(config);

        var filterList = me.getDomainProperty('FilterCollectionProperty');

        if (filterList !== null) {
            filterList.on('cellValueChanged', me.onFilterChanged);
            filterList.on('afterAdd', me.onFilterAdded);
            filterList.on('afterDelete', me.onFilterDeleted);
            filterList.on('cellBeginEdit', me.onFilterBeginEdit);
            filterList.on('propertyChanged', me.onFilterSelectionChanged);

            cat = filterList.Commands;

            cmd = new TS.domain.Command();
            cmd['Code'] = 'EditMultipleValuesFront';
            cmd['Text'] = me.EditMultipleValuesCommandText;
            cmd['handler'] = '_editMultipleValues';
            cmd['IconCode'] = 'ellipsis-v';
            cmd.Enabled(false);

            cat.push(cmd);
        }
    },

    onFilterAdded: function (e) {
        var me = this,
            owner = me._getOwner();

        e.item.OrderNo(this._ListSource().length);
        e.item.MultipleSelection = new ko.observable(false);

        owner.performServerCommand('Dummy', true, null, null, false, true);
    },

    onFilterDeleted: function (e) {
        var me = this,
            owner = me._getOwner();
        var i;
        for (i = 0; i < me._ListSource().length; i++) {
            if (me._ListSource()[i].OrderNo() > e.item.OrderNo()) {
                me._ListSource()[i].OrderNo(me._ListSource()[i].OrderNo()-1);
            }
        }

        var filterList = owner.getDomainProperty('FilterCollectionProperty');
        filterList.invalidate();
    },

    onFilterChanged: function (e) {
        var me = this,
            owner = me._getOwner(),
            val = e.newValue;

        if (e.oldValue === e.newValue)
            return;

        if (e.fieldName === 'ParamId' || e.fieldName === 'OperatorId') {
            owner.performServerCommand({
                cmd: 'RefreshEditorType',
                submitModel: true,
                extraData: {
                    Filter_UID: e.record.UID()
                },
                blockUI: true,                
                callback: function () {
                    me.getFieldByName('OperatorLkp').invalidateList();
                }
            });
        }
    },

    onFilterBeginEdit: function (e) {
        var me = this,
            owner = me._getOwner();

        if (e.fieldName === 'OperatorId') {

            var filters = me.getFieldByName('OperatorLkp').transport.filters;

            var paramIsListFilter;
            var paramTypeIdFilter;

            $.each(filters, function (idx) {
                if (filters[idx].field === 'ParamIsList') {
                    paramIsListFilter = filters[idx];
                }
                if (filters[idx].field === 'ParamTypeId') {
                    paramTypeIdFilter = filters[idx];
                }
            });

            if (!paramIsListFilter) {
                filters.push({ field: 'ParamIsList', value: e.record.ParamIsList(), operator: 'eq' });
                paramIsListFilter = filters[filters.length - 1];
            }
            if (!paramTypeIdFilter) {
                filters.push({ field: 'ParamTypeId', value: e.record.ParamTypeId(), operator: 'eq' });
                paramTypeIdFilter = filters[filters.length - 1];
            }

            paramIsListFilter.value = e.record.ParamIsList();
            paramTypeIdFilter.value = e.record.ParamTypeId();

            me.getFieldByName('OperatorLkp').invalidateList();
        }

        if (e.fieldName === 'FilterValueForDisplay' && e.record.MultipleSelection())
            e.preventDefault();
    },

    onFilterSelectionChanged: function (e) {
        var me = this,
            owner = me._getOwner();

        owner._setEditValuesVisibility();
    },

    _editMultipleValues: function (e) {
        this.performServerCommand({
            cmd: 'EditMultipleValues',
            submitModel: true,
            extraData: {
                Filter_UID: this.FilterCollectionProperty.SelectedItem().UID()
            },
            blockUI: true
        });
    },

    _setEditValuesVisibility: function () {
        var me = this;

        var filterList = me.getDomainProperty('FilterCollectionProperty');
        if (filterList === null)
            return;

        var com = filterList.getCommand('EditMultipleValuesFront');

        if (com === null)
            return;

        var enableCommand = this._editMultipleValuesIsEnabled();

        com.Enabled(enableCommand);
    },

    _editMultipleValuesIsEnabled: function () {

        var filter = this.FilterCollectionProperty.SelectedItem();

        if (!filter)
            return false;

        if (filter.MultipleSelection === null)
            return false;

        if (filter.MultipleSelection() === null)
            return false;

        return filter.MultipleSelection();
    }

});